import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosClient from "../../services/axiosClient";

export const login = createAsyncThunk(
  "user/login",
  async ({ email, password }, thunkAPI) => {
    try {
      const { data } = await axiosClient.post("/api/users/login-otp", {
        email,
        password,
      });
      localStorage.setItem("userInfo", JSON.stringify(data));
      return data;
    } catch (err) {
      return thunkAPI.rejectWithValue(
        err.response?.data?.message || err.message,
      );
    }
  },
);

//TODO, Need to Create for Rest

export const registerFlashUser = createAsyncThunk(
  "user/flash-user",
  async (flashUserData, thunkAPI) => {
    try {
      const { data } = await axiosClient.post(
        "/api/users/flash-user",
        flashUserData,
      );
      localStorage.setItem("flashUser", JSON.stringify(data));
      return data;
    } catch (err) {
      return thunkAPI.rejectWithValue(
        err.response?.data?.message || err.message,
      );
    }
  },
);
